import React from 'react';

export default (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.75 12h16.5M3.75 6h16.5M3.75 18h16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
